import pufferfishModel from "../models/pufferfish.glb";

export const SWIMMERS_3D = [
  {
    type: "pufferfish",
    model: pufferfishModel,
    size: 140,
    animationSpeed: 1,
    behavior: "drift",
    persistent: true,
    drift: {
      area: { x: { min: 0.1, max: 0.9 }, y: { min: 0.15, max: 0.85 } },
      depth: { min: -300, max: 150 },
      speed: { x: 12, y: 8, z: 10 },
      rotationAmplitude: { yaw: 40, pitch: 20, roll: 15 },
      rotationSpeed: 0.15,
    },
  },
];

export const SPAWN_CONFIG_3D = {
  firstCheckDelay: 10000,
  checkDelay: { min: 4000, max: 40000 },
  decay: 0.3,
};
